import { Article, LegalScreen, Points } from '../components/legal';
import { InfoBox } from '../components/ui';

/**
 * プライバシーポリシー。
 *
 * 数字はすべて実装で裏を取った値にしてある。書き換えるときは、対応する場所も
 * 一緒に見ること。
 *   30日   … prod.json の LogRetentionDays
 *   12か月 … prod.json の GroupTtlDays = 365。書き込みのたび ttlFromNow() で延長
 *   35日   … prod.json の BackupRetentionDays
 *   東京    … deploy.ps1 の -Region ap-northeast-1
 *
 * 「名前はログに入らない」は、02-api.yaml の AccessLogSettings.Format の12項目、
 * Lambda の log() 呼び出し、authorizer の console.error を確認したうえで書いている。
 * どれも ID と件数とエラー名しか出していない。ログに本文を足すときはここも直す。
 *
 * 第5条は Google Fonts の記載。index.html と keisan.html が fonts.googleapis.com
 * から書体を読むので、外部送信はゼロではない。自前配信に切り替えたらこの条は消す。
 */
export function PrivacyPage() {
  return (
    <LegalScreen title="プライバシーポリシー" updatedAt="2026年9月3日">
      <p className="text-[13.5px] leading-[1.8] text-ink-soft">
        雀点（以下「本サービス」）における、利用者の情報の取り扱いについて説明します。
      </p>

      <Article no={1} title="取得しない情報">
        <p>本サービスにアカウントはありません。次の情報は一切取得しません。</p>
        <Points
          items={[
            '氏名・住所・電話番号',
            'メールアドレス',
            '生年月日・性別',
            '支払いに関する情報',
          ]}
        />
      </Article>

      <Article no={2} title="入力された情報">
        <p>グループの作成・利用にあたり、次の情報がサーバーに保存されます。</p>
        <Points
          items={['グループ名', 'メンバー名', '対局の点数と日時', 'ルールの設定内容']}
        />
        <p>
          これらは記録・集計・共有という本サービスの機能のためだけに使い、他の目的には使いません。
        </p>
        <InfoBox>
          メンバー名には、本名など個人を特定できる情報を入力しないでください。グループの共有URLを知っている人は、誰でもこれらの情報を閲覧・編集できます。
        </InfoBox>
      </Article>

      <Article no={3} title="端末に保存される情報">
        <p>
          参加中のグループの一覧と、閲覧に必要なアクセストークンを、ブラウザの localStorage
          に保存します。これは端末の中だけに置かれ、サーバーにも第三者にも送信されません。ブラウザのサイトデータを消すと一緒に消えます。
        </p>
        <p>Cookie は使用していません。</p>
      </Article>

      <Article no={4} title="アクセスログ">
        <p>
          サーバーへのリクエストについて、IPアドレスと、リクエストの日時・種類・結果が記録されます。不具合の調査と不正利用の防止のために使い、30日で自動的に削除されます。グループ名やメンバー名がこのログに含まれることはありません。
        </p>
      </Article>

      <Article no={5} title="外部への送信">
        <p>アクセス解析ツール（Google Analytics 等）および広告配信サービスは利用していません。</p>
        <p>
          ただし、画面の書体に Google Fonts
          を使用しているため、ページを開いた際に利用者のIPアドレスとブラウザの情報が Google
          に送信されます。取り扱いについては{' '}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noreferrer"
            className="font-medium text-felt underline underline-offset-2"
          >
            Google のプライバシーポリシー
          </a>{' '}
          をご確認ください。
        </p>
      </Article>

      <Article no={6} title="保存場所と保存期間">
        <p>データは Amazon Web Services の東京リージョン（日本国内）に保存されます。</p>
        <p>
          グループは、最後に操作されてから12か月そのままの場合、自動的に削除されます。グループを開くたびに期限は延長されます。バックアップは最大35日間保持されます。
        </p>
      </Article>

      <Article no={7} title="データの削除">
        <p>
          グループの設定画面から、いつでもグループごと削除できます。削除すると、そのグループのメンバー・対局・ルールもあわせて消え、元に戻せません。
        </p>
      </Article>

      <Article no={8} title="お問い合わせ">
        <p>本ポリシーに関するご質問は、お問い合わせのページをご覧ください。</p>
      </Article>

      <Article no={9} title="変更">
        <p>本ポリシーを変更する場合は、このページを更新し、最終更新日を書き換えます。</p>
      </Article>
    </LegalScreen>
  );
}
